import { Injectable } from '@angular/core';

export enum StorageKey {
    'USER' = 'sf-user',
    'CUSTOMIZATION' = 'sf-customization',
    'OPEN_CATEGORY' = 'sf-open-category',
    'ACTIVE_FILTER' = 'sf-active-filter',
    'EVENT_CALENDAR_QUERY' = 'sf-event-calendar'
}

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    get<T>(key: StorageKey): T {
        return JSON.parse(localStorage.getItem(key)!);
    }

    set<T>(key: StorageKey, value: T): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    remove(key: StorageKey): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }
}
